"use strict"

jQuery( document ).ready(function() {

	jQuery(function($) {

		if ($('.press-releases').length) {
			var scrollPosition = 0,
				fixPage = false,
				page = 0,
				getPressReleaseHistory = false;

				if (getCookie("pressReleaseHistory")) {
					getPressReleaseHistory = JSON.parse(getCookie("pressReleaseHistory"));
				}

			console.log("Cookies goBack: ", getPressReleaseHistory.goBack);

			// reset cookies
			createCookie('pressReleaseHistory','', 5);

			jQuery(document).on("click", ".press-release-action", function() {
				scrollPosition = jQuery(window).scrollTop();
				localStorage.setItem("scroll", scrollPosition);

				var countVal = jQuery(".cst-count article").length,
					filterVal = null,
					$filter = jQuery(".facetwp-radio"),
					$checked = jQuery(".filter-bar .checked");

					if ($($filter).hasClass("checked")) {
						filterVal =  $($checked ).data("value");
					}

				var cookiesData = {
					count: countVal,
					scroll: scrollPosition,
					filter: filterVal,
					goBack: true
				}
				var $jsonEncodeData = JSON.stringify(cookiesData);
				createCookie('pressReleaseHistory', $jsonEncodeData, 5);
			});

			// FacetJS
			if (getPressReleaseHistory) {
				page = getPressReleaseHistory.count / 6;
			}

			$(document).on('click', '.facetwp-load-more', function() {
				if (getPressReleaseHistory.goBack === true) {
					if (fixPage === false ) {
						fixPage = true;
						FWP.load_more_paged = page; // next page
						//getPressReleaseHistory = "";
						console.log("Page trigered: ",	FWP.load_more_paged);
					}
				}
			});
		}
	});

	function createCookie(name,value,days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			var expires = "; expires="+date.toGMTString();
		}
		else var expires = "";
		document.cookie = name+"="+value+expires+"; path=/";
	}

	function getCookie(cname) {
		let name = cname + "=";
		let ca = document.cookie.split(';');
		for(let i = 0; i < ca.length; i++) {
		  let c = ca[i];
		  while (c.charAt(0) == ' ') {
			c = c.substring(1);
		  }
		  if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		  }
		}
		return "";
	}

});